import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import InputValueProps from '../../../../../../prop-types/input-value-props';
import { propertyForUpdateByActionType } from '../../../helpers/property-for-update-by-action-type';
import messages from '../messages';
import classnames from 'classnames';
import style from '../../style.module.less';
import sharedStyles from '../../../../../../style.module.less';

const SingleSelectDropdown = ({ actionTypeId, allowedActions, inputValueProps, onChange, label }) => {
  const propertyForUpdate = propertyForUpdateByActionType(actionTypeId);
  const onActionChange = useCallback(
    (value) => {
      onChange({
        [propertyForUpdate]: value,
      });
    },
    [onChange, propertyForUpdate],
  );
  const selectedAction = allowedActions.find((action) => action[propertyForUpdate] === inputValueProps[propertyForUpdate]);
  return (
    <div className={classnames(style['action-selector'], style['multi-control-row'])}>
      <div>{label}</div>
      <DropdownMenu className={sharedStyles['dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler className={sharedStyles['dropdown-toggler']}>
          {selectedAction && selectedAction.name}
          {!selectedAction && <FormattedMessage {...messages.noOptionSelectedMessage} />}
        </DropdownMenuToggler>
        {allowedActions.map((actionType) => {
          return (
            <DropdownMenuItem
              key={actionType[propertyForUpdate]}
              className={sharedStyles['dropdown-item']}
              onClick={() => onActionChange(actionType[propertyForUpdate])} // TODO: remove anon when dropdown supports typing for a further nested element
              theme='unstyled'
            >
              {actionType.name}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
    </div>
  );
};

SingleSelectDropdown.propTypes = {
  actionTypeId: PropTypes.number.isRequired,
  allowedActions: PropTypes.array.isRequired,
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
};

export default SingleSelectDropdown;
